module.exports = __webpack_public_path__ + "img/room01_bookB.da194200.png";